module.exports = __webpack_public_path__ + "static/media/crypto_tomb_cash.c44f7ab6.svg";